/*
  This page is for Login or Register
  Author: Surojit Basu
  Date: June 07, 2020
*/
import React,{useEffect,useState,useContext} from 'react';
import {  
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Alert,
  ProgressBar
} from 'react-bootstrap';

import { useParams } from 'react-router-dom';
import {MessageModal} from '../components';

import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login';

import UserContext from './../contexts/UserContext';

import './login.css';

import _ from 'lodash';
import Utils from './../Utils';


const GoogleButton = (props) => {
  return <GoogleLogin
    clientId={process.env.REACT_APP_GOOGLE_KEY}
    render={renderProps => (<img src={props.imgPath} onClick={renderProps.onClick} className="btn p-0" alt="Google" />)}    
    onSuccess={props.onSubmit}
    onFailure={props.onSubmit}
    cookiePolicy={'single_host_origin'}
  />
}

const FacebookButton = (props) => {
  // console.log(process.env.REACT_APP_FACEBOOK_APP_ID);
   return <FacebookLogin
     appId={process.env.REACT_APP_FACEBOOK_APP_ID}    
     render={renderProps =>(<img src={props.imgPath} onClick={renderProps.onClick} className="btn p-0" alt="FB" />)}    
     fields="name,email"  
     callback={props.onSubmit} 
     cssClass="facebook-btn"    
     textButton=""
     version="3.1"
     />
 }

const Login = (props) => {

  const isRegister = window.location.pathname=== process.env.PUBLIC_URL + '/register';
  const isFrgpwd = window.location.pathname=== process.env.PUBLIC_URL + '/forgot-password';
  const isLogin = !isRegister && !isFrgpwd;

  const {goLogin, goFrgpwd ,goRegistration, selectedPackage, thirdPartyLogin} = useContext(UserContext);
  const [init,setInit] = useState(false);
  const [loading,setLoading] = useState(false);
  const [message,setMessage] = useState(false);
  const [data,setData] = useState(false);
  const {src, username} = useParams();
 
  useEffect(()=>{ 
    if(src === "third"){
      thirdPartyLogin(username, authCallback);
    }else{
      if(!Utils.isLoggedIn()){
        setInit(false);
      }else if(selectedPackage()!==false){      
        window.location.href = process.env.PUBLIC_URL + '/pay';
      }else{
        window.location.href = process.env.PUBLIC_URL + '/builder';
      }   
    }
  },[]);
  
  const onSubmit = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();
    var data = {
      username : frm.username.value
    };
    if(!isFrgpwd){
      data['password'] = frm.password.value;
    }    
    
    if(isRegister){
      data['name']=frm.name.value;      
      data['source']='website'; 
      
      //to check whether user redirected from buy-now or not
      //this is for security usp task(buy process in same browser)
      if(selectedPackage()){
        data['buyer']='1';
      }
      else{
        data['buyer']='0';
      }       
    }
    
    setData(data);

    if(isRegister && data['password'].localeCompare(frm.confpass.value)!==0){
      setMessage(['error',['Confirm password does not match! Password are case sensitive.']]);
      return false;
    }

    //to redirect user to buy-now if pacakage is selected
    if(isRegister && Utils.isLoggedIn() && selectedPackage())
    {
      window.location.href = process.env.PUBLIC_URL + '/pay'
    }

    setLoading(true);
    (isRegister? goRegistration : (isFrgpwd ? goFrgpwd : goLogin))(data,authCallback);
  }

  const authCallback = (success,message, flag) => {
    setLoading(false);
    if(isRegister || !success){  
      if(flag==='AC'){
        window.setTimeout(function(){
          window.location.href= process.env.PUBLIC_URL + '/register';
        },3000);  
      }    
      setMessage([success ? 'success' : 'error',message]);
    }
    if(isRegister && flag==='AC'){
      window.setTimeout(function(){
        window.location.href= process.env.PUBLIC_URL + '/register';
      },3000);
    }  
    if(isFrgpwd){
      if(flag==='AC'){
        window.setTimeout(function(){
          window.location.href= process.env.PUBLIC_URL + '/register';
        },3000);
      }
      setMessage([success ? 'success' : 'error', message]);      
    }
    if(success && (isLogin || (isRegister && Utils.isLoggedIn()))){
      window.setTimeout(function(){
        if(selectedPackage()){
          window.location.href = process.env.PUBLIC_URL + '/pay';
        }else{  
          window.location.href=process.env.PUBLIC_URL + '/builder';
        }
      }, 2000);
    }
    else{
      window.setTimeout(function(){
        if(isLogin && flag==='AC'){
          window.location.href = process.env.PUBLIC_URL + '/register';
        }
      },3000);      
    }
  };

  const onGoogleLogin = (obj) => {
    //console.log(obj);
    if(obj !==undefined){
      const profileObj = obj.profileObj;
      var data = {
        username: profileObj.email,
        name: profileObj.name,
        password: "",
        picture: profileObj.imageUrl,
        source: 'google'
      };
      setLoading(true);
      goRegistration(data,authCallback);

    }

    
  }

  const onFacebookLogin = (profileObj) => {
    if(profileObj !==undefined){
      var data = {
        username: profileObj.email,
        name: profileObj.name,
        password: "",
        source: 'facebook'
      };
      setLoading(true);
      goRegistration(data,authCallback);
  
    }
  }

  return <Container className="h-100 d-flex justify-content-center align-items-center">    
    <Card className="card-shadowed">
      <Card.Body>
        <Row>
          <Col><a href="/"><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} className="logo" /></a></Col>
        </Row>
        <Row>
          <Col className="header">                          
              {isFrgpwd && <span>Enter your Email address and we’ll send you a link to reset your password.</span>}
              {!isFrgpwd && <span>We are happy to see you.</span>}
          </Col>
        </Row>

        {message && <MessageModal type={message[0]} message={message[1]} onHide={() => {setMessage(false);}} />}

        {loading && <Alert variant="light" className="p-3">
          <p className="loading-msg">Authorization check</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>}
        
        {!loading && <>
          
          {!isFrgpwd && <Row>
            <Col>
              <Row>
                <Col className="pr-0 pt-1" style={{maxWidth: '100px'}}>LogIn with</Col>
                {/* <Col className="pl-0 pr-0" style={{maxWidth: '34px'}}>
                  <FacebookButton imgPath={`${process.env.PUBLIC_URL}/images/fb_icon.png`} onSubmit={onFacebookLogin} /></Col> */}
                <Col className="pl-1" style={{maxWidth: '80px'}}>  <GoogleButton imgPath={`${process.env.PUBLIC_URL}/images/google_icon.png`} onSubmit={onGoogleLogin} /></Col>
              </Row>
            </Col>
          </Row>}

          {!src &&  <Form className="mt-4 mb-4" onSubmit={onSubmit}>
              <Row>
                <Col>
                  {isRegister && <Form.Control required className="input-text" type="text" placeholder="Full name" name="name" defaultValue={data.name} />}
                  <Form.Control required className="input-text" type="email" placeholder="Email" name="username" defaultValue={data.username} />                
                  {!isFrgpwd && <Form.Control required className="input-text" type="password" placeholder="Password" name="password" defaultValue={data.password} />}
                  {isRegister && <Form.Control required className="input-text" type="password" placeholder="Confirm password" name="confpass" />}
                </Col>
              </Row>
              <Row className="mt-4 mb-4">
                {isRegister && <>
                  <Col className="text-center"><Button type="submit" className="p-0 clear"><img src={`${process.env.PUBLIC_URL}/images/signup_button.png`} alt="Signup" /></Button></Col>
                  <Col className="text-center"><a href={`${process.env.PUBLIC_URL}/login`}><img src={`${process.env.PUBLIC_URL}/images/login_grey_button.png`} alt="Login" /></a></Col>
                </>}
                {isLogin && <>
                  <Col className="text-center"><Button type="submit" className="p-0 clear"><img src={`${process.env.PUBLIC_URL}/images/login_button.png`} alt="Login" /></Button></Col>
                  <Col className="text-center"><a href={`${process.env.PUBLIC_URL}/register`}><img src={`${process.env.PUBLIC_URL}/images/register_button.png`} alt="Register" /></a></Col>
                </>}
                {isFrgpwd && <>
                  <Col className="text-right"><Button type="submit" className="p-0 clear"><img src={`${process.env.PUBLIC_URL}/images/forgot_pass_button.png`} alt="Login" /></Button></Col>                
                </>}
              </Row>
              <Row>
              {!isFrgpwd && <Col><strong>Forgot Password?</strong> <a href={`${process.env.PUBLIC_URL}/forgot-password`}>Click here!</a></Col>}
              {isFrgpwd && <Col><a href={`${process.env.PUBLIC_URL}/login`}>Try logging in!</a></Col>}
              </Row>
            </Form>}
            {src === 'third' && <MessageModal type={message[1]} message={'Logging in... please wait..'} onHide={() => {setMessage(false);}} /> }

        </>}
      </Card.Body>
    </Card>  
  </Container>

}

export default Login;